import { FilterPredicate } from "../FilterPredicate";
export const Filters = {
    [FilterPredicate.Sport]: {
        collections: ["events", "markets", "leagues"],
        fn: "filterBySport"
    },
    [FilterPredicate.Date]: {
        collections: ["events", "markets"],
        fn: "filterBySportAndDate"
    },
    [FilterPredicate.LiveStreaming]: {
        collections: ["events"],
        fn: "filterByLiveStream"
    },
    [FilterPredicate.Favorites]: {
        collections: ["events"],
        fn: "filterByFavorites"
    }
};
//# sourceMappingURL=Filters.js.map